import { render, staticRenderFns } from "./MbHeader.vue?vue&type=template&id=586e4f71&scoped=true&"
import script from "./MbHeader.vue?vue&type=script&lang=js&"
export * from "./MbHeader.vue?vue&type=script&lang=js&"
import style0 from "./MbHeader.vue?vue&type=style&index=0&id=586e4f71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586e4f71",
  null
  
)

export default component.exports